import { render, staticRenderFns } from "./StatisticsDesc.vue?vue&type=template&id=35e3546d&"
import script from "./StatisticsDesc.vue?vue&type=script&lang=js&"
export * from "./StatisticsDesc.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDesc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports